import { render, staticRenderFns } from "./DiarioOficial.vue?vue&type=template&id=7d7fc6f6&scoped=true&"
import script from "./DiarioOficial.vue?vue&type=script&lang=js&"
export * from "./DiarioOficial.vue?vue&type=script&lang=js&"
import style0 from "./DiarioOficial.vue?vue&type=style&index=0&id=7d7fc6f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7fc6f6",
  null
  
)

export default component.exports